module.exports = __webpack_public_path__ + "img/shejizhijia.87a1b23d.png";